import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
export interface DeleteDialogData {
	title?: string;
	message?: string;
	confirmText?: string;
	cancelText?: string;
}
@Component({
	selector: 'app-delete-dialog-box',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule, MatIconModule],
	templateUrl: './delete-dialog-box.component.html',
	styleUrl: './delete-dialog-box.component.scss'
})
export class DeleteDialogBoxComponent {

	
	constructor(
		private dialogRef: MatDialogRef<DeleteDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DeleteDialogData
	) { }

	closeDialog(result: boolean): void {
		this.dialogRef.close(result);
	}

}
